import { render, staticRenderFns } from "./DiagnosticImageCategoryEdit.vue?vue&type=template&id=38fcb1fa"
import script from "./DiagnosticImageCategoryEdit.vue?vue&type=script&lang=js"
export * from "./DiagnosticImageCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports